import { useState } from 'react'

import { Banner, FormattedMessage } from '@b-stock/fe-core/bstock-react'

const ns = 'BidConfirmationModal.autoPay'

export const AutoPayInfoBanner = () => {
  const [isVisible, setIsVisible] = useState(true)

  return (
    isVisible && (
      <div data-testid="auto-pay-info-banner">
        <Banner
          type="info"
          title={<FormattedMessage id={`${ns}.banner.title`} />}
          onDismiss={() => {
            setIsVisible(false)
          }}
        >
          <FormattedMessage id={`${ns}.banner.description`} />
        </Banner>
      </div>
    )
  )
}
